<template>
  <el-form-item :label="labelContent" :prop="prop" :rules="ruleObj">
    <DeptSelect
      v-model="model"
      :multiple="multiple"
      :disabled="disabled"
      filterable
      clearable
      :is-all="isAll"
      @input="modelChange"
      @selectedNodesChange="selectedNodesChange"
      @change="changeDept"
    />
  </el-form-item>
</template>
<script setup>
import { ref, watch, computed, inject } from 'vue'
import DeptSelect from './index.vue'

const props = defineProps({
  label: {
    type: String,
    default: '所属部门',
  },
  prop: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Number, Array],
    default: null,
  },
  useType: {
    type: String,
    default: 'search', // search 搜索区域,unSearch 非搜索区域
  },
  required: {
    type: Boolean,
    default: true,
  },
  isAll: {
    type: Boolean,
    default: false,
  },
  multiple: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  labelKey: {
    type: String,
  },
})

// base-list-management注入的用于获取options的方法
const updateOptions = inject('updateOptions', null)

const emit = defineEmits(['input', 'selectedNodesChange'])

const model = ref(props.value)

const labelContent = computed(() => {
  if (props.useType === 'search') {
    return props.label.replace(/[:：]/g, '')
  } else {
    return `${props.label.replace(/[:：]/g, '')}:`
  }
})

const ruleObj = computed(() => {
  // 传入prop的话，需要进行必填校验
  return props.required ? [{ required: true, message: '请选择所属部门' }] : []
})

const modelChange = (val) => {
  emit('input', val)
}

const selectedNodesChange = (val) => {
  emit('selectedNodesChange', val)
}

const changeDept = (_, options) => {
  // 将选项打平返回给base-list-management
  updateOptions && updateOptions(props.labelKey, options)
}


watch(() => props.value, (val) => {
  model.value = val
})
</script>
<script>
export default {
  name: 'DeptTree',
}
</script>
